import { Employee, UserPermissions } from "generated/graphql";
import Restore from "./Restore";
import { useCheckPermissions } from "hooks/authentication/useCheckPermissions";

export default function ArchivedMenuItems({
  id,
  closeMenu,
}: {
  id: Employee["id"];
  closeMenu: () => void;
}) {
  const { hasPermissions } = useCheckPermissions();
  if (!hasPermissions(UserPermissions.MANAGE_EMPLOYEES)) {
    return <></>;
  }
  return (
    <>
      <Restore closeMenu={closeMenu} id={id} />
    </>
  );
}
